module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt_BR":{"default":{"title":"Processando o seu pagamento via Paypal","description":"Isto pode demorar algum tempo..."},"success":{"title":"Tudo certo! Pagamento paypal executado!","description":"Agora é só esperar o Paypal nos notificar para liberarmos seus créditos!"},"error":{"title":"Ops, houve algum erro...","description":"Por favor, efetue novamente a compra, se o erro persistir entre em contato."}}}')
  delete Component.options._Ctor
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/@kazupon/vue-i18n-loader/lib!./node_modules/vue-loader/lib/selector.js?type=customBlocks&index=0!./src/components/Invoice/Paypal.vue
// module id = 159
// module chunks = 0